import React from "react";
import { Modal } from "react-bootstrap";

export default function PmgMechanismModal(props) {
  const { show, closeModal } = props;

  return (
    <React.Fragment>
      <Modal
        show={show}
        dialogClassName="banner-modal"
        onHide={closeModal}
        data-test="pmg-mechanism-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Project Monitoring Group (PMG)
            <h6>Institutional Mechanism for Issue Resolution</h6>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <h5>
            Requisite Conditions for an Investor to Upload a Project on the PMG
            Portal
          </h5>

          <p>
            In order for any investor or project proponent (PP) to upload a
            project and its issues for resolution through the mechanism, it must
            meet certain requirements. These conditions can be found here:
          </p>

          <ol>
            <li>
              The project being uploaded on the PMG portal must meet the
              investment threshold of being of &#8377; 500 Cr. (approximately
              US$ 75 million) or more in value. Projects that do not meet this
              threshold may be uploaded on the issue resolution portal of the
              State-government where they are located.
            </li>
            <li>
              Projects that do not meet this threshold can be uploaded onto the
              PMG portal if they are deemed critical for the nation’s growth and
              development. However, such is subject to approval from the
              Department of Industry and Internal Trade (DPIIT).
            </li>
            <li>
              The projects must have pending issues at the Central or
              State-level for which they seek resolution.
            </li>
          </ol>

          <h5>Stages of Issue Resolution</h5>

          <ol>
            <li>
              The Project Proponent (PP) must create login credentials in order
              to be able to upload their project onto the PMG Portal.
            </li>
            <li>
              All the details pertaining to the project, including project
              location, issue faced, and current status of project must be
              uploaded onto the Portal by the PP.
            </li>
            <li>
              Once the project has been uploaded, the Sponsoring Ministry
              verifies the project and the issues stated on it.
            </li>
            <li>
              After verification, PMG takes up the issues with the concerned
              Ministries and States by holding tripartite meetings. The PP is
              required to attend these meetings for the resolution of their
              issues.
            </li>
            <li>
              The status as well as minutes of the meeting are uploaded onto the
              portal after every resolution meeting by the concerned Ministry
              and/or State.
            </li>
            <li>
              After the issue is resolved, it is dropped from the PMG portal
              after securing agreement from the PP as well as the concerned
              government officials.
            </li>
          </ol>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
